import styled from 'styled-components'

type Props = {
	shouldExpand?: boolean
	textAlign?: 'left' | 'center' | 'right'
}

export const Cell = styled.div<Props>`
	/* Positioning */
	flex: ${({ shouldExpand }) => (shouldExpand ? '1' : null)};
	text-align: ${({ textAlign = 'left' }) => textAlign};

	overflow-wrap: anywhere;
`
